// Coda dei problemi aperti. È la stessa sorgente che alimenta il pannello
// "Richiede la tua attenzione" dello Stato piattaforma e la Risoluzione assistita:
// un incidente non deve esistere in due elenchi diversi.

export type Gravita = 'bloccante' | 'sorveglianza';
export type Destinatario = 'code' | 'design' | 'ticket';
export type Richiesta = 'diagnosi' | 'patch' | 'staging';

export interface Incidente {
  id: string;
  titolo: string;
  strato: string;
  gravita: Gravita;
  sintomo: string;
  contesto: string;
  verificato: string;
  atteso: string;
}

export const STACK: string = [
  'Stack: React 19.2 + Vite 7.3 + TypeScript 5.9, TanStack Router 1.95 e Query 5.62, Zustand 5,',
  'Bootstrap Italia 2.13, react-hook-form 7.75 + zod 4.4, oidc-client-ts 3.1 su Keycloak (realm urania-test).',
  'Backend: gateway di inferenza con modelli on-premise (Llama 3.3 70B, Qwen2.5 72B) e cloud UE in fallback;',
  'RAG con tre corpora per fondo (FESR v12, FSE+ v8, FEASR v4), embedding e5-large-v2 on-prem.',
  'Vincoli non negoziabili: i dati sensibili non escono verso il cloud; nessun atto e protocollabile senza',
  'validazione umana; obblighi di trasparenza AI Act (Reg. UE 2024/1689 art. 50 e L. 132/2025).',
].join('\n');

export const INCIDENTI: Incidente[] = [
  {
    id: 'protocollo', titolo: 'Protocollo informatico non configurato', strato: 'Produzione', gravita: 'bloccante',
    sintomo: 'Nessun atto puo essere registrato: la piattaforma non e utilizzabile in produzione.',
    contesto: 'Integrazione mai inizializzata: nessun handshake registrato. Gli altri connettori (OnlyOffice v8.1, Keycloak) sono attivi.',
    verificato: 'Le bozze validate restano nello stato "pronta per il protocollo" senza errori applicativi.',
    atteso: 'Definire il connettore di segnatura e la sequenza di registrazione, con gestione degli errori e ritentativi.',
  },
  {
    id: 'feasr', titolo: 'Ingest FEASR fallito (OCR)', strato: 'Conoscenza', gravita: 'bloccante',
    sintomo: '14 documenti fuori dal corpus da 3 giorni. Le risposte sul FEASR sono incomplete e non lo dichiarano.',
    contesto: 'Job di ingest in errore su PDF scansionati, chunking semantico 800/120, embedding e5-large-v2 on-prem. Gli altri 312 documenti sono indicizzati.',
    verificato: 'Il job e stato riavviato due volte con lo stesso esito; gli altri due corpora indicizzano senza errori.',
    atteso: 'Capire se il problema e nel layer OCR o nella pipeline di chunking, e come far dichiarare al sistema che il corpus e incompleto.',
  },
  {
    id: 'skill', titolo: 'Skill "Risposta a rilievo di audit" sotto soglia', strato: 'Intelligenza', gravita: 'sorveglianza',
    sintomo: 'Eval di conformita 0,81 contro una soglia di 0,90. La skill e ancora invocabile in staging.',
    contesto: 'Prompt v3 in bozza, corpus FESR, Llama 3.3 70B, temperatura 0,1. Citazioni valide 88%.',
    verificato: 'Le altre tre skill superano 0,93 con lo stesso modello e lo stesso corpus.',
    atteso: 'Capire se il problema e il prompt, il retrieval o il set di valutazione, e come impedire l uso in produzione.',
  },
  {
    id: 'revisione', titolo: '7 bozze in attesa di revisione umana', strato: 'Produzione', gravita: 'sorveglianza',
    sintomo: 'La bozza piu vecchia attende da 9 giorni. Nessuna e protocollabile finche non e validata.',
    contesto: 'Nessun meccanismo di assegnazione o sollecito: la coda e implicita e nessuno la presidia.',
    verificato: 'I revisori hanno il permesso corretto; il blocco non e tecnico ma organizzativo.',
    atteso: 'Progettare assegnazione, scadenze e solleciti senza trasformare la validazione in un timbro automatico.',
  },
  {
    id: 'tetto', titolo: 'Mistral Large a tetto di spesa', strato: 'Intelligenza', gravita: 'sorveglianza',
    sintomo: 'Tetto di 500 euro raggiunto: il traffico e dirottato sui modelli on-premise.',
    contesto: 'Il dirottamento funziona, ma il modello che ha risposto cambia a metà lavorazione di uno stesso atto.',
    verificato: 'La catena di fallback si attiva correttamente; il fascicolo registra entrambi i modelli.',
    atteso: 'Decidere se il dirottamento a metà atto sia accettabile e come dichiararlo nel fascicolo.',
  },
  {
    id: 'reindex', titolo: 'Reindicizzazione FSE+ ferma al 41%', strato: 'Conoscenza', gravita: 'sorveglianza',
    sintomo: 'Avanzamento invariato da 12 minuti, nessun errore riportato.',
    contesto: '61.130 chunk, snapshot v8 ancora attivo durante la reindicizzazione. Un nodo GPU su tre non risponde.',
    verificato: 'Il job non e in errore: e in attesa. Nessun timeout configurato.',
    atteso: 'Capire se e contesa di GPU o un blocco della coda, e introdurre un timeout con avviso.',
  },
  {
    id: 'gpu', titolo: 'Un nodo GPU su tre non risponde', strato: 'Intelligenza', gravita: 'sorveglianza',
    sintomo: 'Occupazione al 68% su due nodi; il terzo non compare tra quelli attivi.',
    contesto: 'Nessun allarme generato: il gateway ha semplicemente smesso di instradare verso quel nodo.',
    verificato: 'Le richieste non vanno in errore, la latenza p95 e salita a 3,2 s.',
    atteso: 'Capire perche la perdita di un nodo non genera un avviso e come esporla nel cruscotto.',
  },
];

export const DESTINATARI: Record<Destinatario, string> = {
  code: 'Il destinatario e Claude Code, che ha accesso al repository: indica i percorsi dei file da toccare e i comandi da eseguire.',
  design: 'Il destinatario si occupa dell interfaccia: concentrati su schermate, stati, accessibilita e testi, non sull implementazione.',
  ticket: 'Il destinatario e un ticket interno letto anche da un funzionario non tecnico: spiega in italiano semplice, senza gergo.',
};

export const RICHIESTE: Record<Richiesta, string> = {
  diagnosi: 'Voglio solo la diagnosi: non propormi codice.',
  patch: 'Voglio la diagnosi e la patch minima, con i file da modificare.',
  staging: 'Voglio la diagnosi, la patch minima e la sequenza per applicarla e verificarla in staging.',
};

export const GRAVITA_COL: Record<Gravita, string> = { bloccante: '#c0392b', sorveglianza: '#e8b829' };
